import axios from "axios";
import { Dispatch } from "redux";

import setAuthToken from "../utils/setAuthToken";
import formatUsername from "../utils/formatUsername";
import { loading, signOut, setError, signIn } from "./authSlice";

export const login =
  (username: string, password: string) => async (dispatch: Dispatch) => {
    dispatch(loading());
    try {
      const res = await axios.post<{ token: string; authorized?: boolean }>(
        "/api/auth/dashboard",
        {
          username: username,
          base64: Buffer.from(username + ":" + password).toString("base64"),
        }
      );

      setAuthToken(res.data.token);

      dispatch(
        signIn({
          username: formatUsername(username),
          token: res.data.token,
          authorized: res.data?.authorized,
        })
      );
    } catch (err) {
      dispatch(setError());
    }
  };

export const restoreToken = () => async (dispatch: Dispatch) => {
  if (localStorage.authToken) {
    try {
      const res = await axios.get<{ username: string; authorized?: boolean }>(
        "/api/auth/dashboard/validate"
      );
      dispatch(
        signIn({
          username: formatUsername(res.data.username),
          authorized: res.data?.authorized,
        })
      );
    } catch (err) {
      dispatch(signOut());
    }
  } else {
    dispatch(signOut());
  }
};
